<template>
    <div>
        <b-card :header="uLang('app.edit')" header-tag="h4" class="bg-default-card">
            <form-admin-relation :id="id"></form-admin-relation>
        </b-card>
    </div>
</template>

<script>
    import FormAdminRelation from '~/components/forms/admin/relation/form'

    export default {
        name: 'edit',
        props: {
            id: {
                required: true,
            },
        },
        components: {
            'form-admin-relation': FormAdminRelation,
        },

   }
</script>

<style lang="css" scoped>
</style>
